import userRestRepository from "@/data/restApi/userRestRepository";

export interface UserRepository {
  login(password: string): Promise<void>;
  logout(): Promise<void>;
}

const userRepository: UserRepository = userRestRepository;
export default userRepository;
